import store from '@/store';
import { performRequest } from '@/common/network';
import { handleApiResponse } from '@/common/serviceResponse';

export default {

    async checkEmail(email) {
        const response = await performRequest(process.env.VUE_APP_APIURL + '/api/v1/login/check-email', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        }, { service: 'AuthService.checkEmail', payload: '[redacted]' });
        return handleApiResponse(response, { unauthorized: 'message', expectSuccess: true });
    },

    async login(credentials) {
        const url = process.env.VUE_APP_APIURL + '/api/v1/login';
        const response = await performRequest(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        }, {
            service: 'AuthService.login',
        });
        return handleApiResponse(response, {
            unauthorized: 'message',
            expectSuccess: true,
        });
    },

    async settings() {
        const url = process.env.VUE_APP_APIURL + '/api/v1/company/' + store.state.site.id + '/get-settings';
        const response = await performRequest(url, {
            headers: {
                'Accept': 'application/json',
            }
        }, {
            service: 'AuthService.settings',
            siteId: store.state.site.id,
        });
        return handleApiResponse(response, {
            unauthorized: 'message',
        });
    }

}
